import React, {useContext, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useAppConfig, useForceRefetchConfig} from "../../modules/local/AppConfigContext";
import {LoginContext} from "../LoginContext";

export const UnderConstruction = () => (
    <div style={{textAlign: 'center', paddingTop: '100px'}}>
        <h1>🚧 Under Construction 🚧</h1>
        <p>We're currently performing maintenance. Please check back later.</p>
    </div>
);

const EXCLUDED_PATHS = new Set([
    '/login',
    '/logout'
]);

const MAINTENANCE_KEYS = ['is_maintenance', 'mobile_app_configs'];

const MaintenanceWrapper = ({children}) => {
    const location = useLocation();
    const refetch = useForceRefetchConfig();

    useEffect(() => {
        refetch(MAINTENANCE_KEYS);
    }, []); // eslint-disable-line

    const {is_maintenance = false} = useAppConfig(...MAINTENANCE_KEYS, {skip: true});
    const login = useContext(LoginContext);

    const isExcludedPath = EXCLUDED_PATHS.has(location?.pathname);
    const isAdminUser = !!login?.edit_system;

    const shouldShowMaintenance = Boolean(is_maintenance) && !isAdminUser && !isExcludedPath;

    if (shouldShowMaintenance) {
        return <UnderConstruction/>;
    }

    return children;
};

export default MaintenanceWrapper;